import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { tap } from 'rxjs/operators';

import { CostCenter } from '../entities/costCenter';
import { SpinnerService } from './spinner.service';
import { EmployeeStatistics } from '../model/employee-statistics';
import { EmployeeStatisticsStart } from '../model/employee-statistics-start';
import { LazyLoadEvent } from '../../../../node_modules/primeng/primeng';
import { EmployeeStatisticsAttendance } from '../model/employee-statistics-attendance';

@Injectable()
export class EmployeeStatisticService {

  protected rutaServidor = localStorage.getItem('rutaServidor');
  protected httpParams = new HttpParams();
  protected uri = '/api/employee/statistic';

  constructor(
    private httpClient: HttpClient,
    private spinnerService: SpinnerService
  ) {
   //console.log('Instance EmployeeStatisticService');
  }

  statistic(costCenter: CostCenter): Observable<EmployeeStatistics[]> {
    // debugger;
    const url = `${this.rutaServidor}${this.uri}/${costCenter.id}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<EmployeeStatistics[]>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  statisticAttendance( employee: number, fiscalYear: number,  executingUnit : number, costCenter: number): Observable<EmployeeStatisticsAttendance> {
    // debugger;
    const url = `${this.rutaServidor}${this.uri}/Attendance/${employee}/${fiscalYear}/${executingUnit}/${costCenter}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<EmployeeStatisticsAttendance>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }  
  statisticForEmployeeIncome(employeeId: number, event?: LazyLoadEvent): Observable<EmployeeStatisticsStart[]> {
    const url = `${this.rutaServidor}${this.uri}/income/${employeeId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<EmployeeStatisticsStart[]>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  statisticForEmployeeAttendanceDeduction(employeeId: number, event?: LazyLoadEvent): Observable<EmployeeStatisticsStart[]> {
    const url = `${this.rutaServidor}${this.uri}/deductions/${employeeId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<EmployeeStatisticsStart[]>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  statisticForEmployeeAbsences(employeeId: number, event?: LazyLoadEvent): Observable<EmployeeStatisticsStart[]> {
    const url = `${this.rutaServidor}${this.uri}/absences/${employeeId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<EmployeeStatisticsStart[]>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeDelays(employeeId: number, period: string): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/delays/${employeeId}/${period}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeDelaysWeekly(employeeId: number, year: string, weekNumber: string): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/delaysW/${employeeId}/${year}/${weekNumber}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeVacationDays(employeeId: number): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/vacation/${employeeId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeVacationDaysProportional(employeeId: number): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/vacationP/${employeeId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeExtraHours(employeeId: number, year: string, euId: number): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/extraHours/${employeeId}/${year}/${euId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeExtraHoursPrevius(employeeId: number, year: string, euId: number): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/extraHoursP/${employeeId}/${year}/${euId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  periodExtraHours(year: string, euId: number): Observable<string> {
    const url = `${this.rutaServidor}${this.uri}/period/${year}/${euId}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<string>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  indicatorForEmployeeHoursReturn(employeeId: number, period: string): Observable<number> {
    const url = `${this.rutaServidor}${this.uri}/hoursReturn/${employeeId}/${period}`;
    this.spinnerService.showAll();
    return this.httpClient
      .get<number>(url)
      .pipe(
        tap(response => {
         //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-statistic.service.ts